<template>
  <div class="form-group" :class="{'input-group': hasIcon}">
    <slot name="label">
      <label v-if="label" class="control-label" :for="cusName">
        {{label}}
      </label>
    </slot>
    <slot name="addonLeft">
      <span v-if="addonLeftIcon" class="input-group-addon">
        <i :class="addonLeftIcon"></i>
      </span>
    </slot>
    <textarea :rows="rows" :cols="cols" style="height: 100%;"
      @input="inputEvent('input',$event.target.value)"
      @blur="inputEvent('input',$event.target.value)"
      v-bind="$attrs"
      class="form-control"
      aria-describedby="addon-right addon-left"
      autocomplete="off"
      :class="{'is-invalid': hasErrors && hasErrors.has(cusName), 'is-valid': isInputValid()}"
      :id="cusName"
      :name="cusName"
      :value="value"
      >
    </textarea>
    <slot></slot>
    <slot name="addonRight">
      <span v-if="addonRightIcon" class="input-group-addon">
        <i :class="addonRightIcon"></i>
      </span>
    </slot>
    <div v-show="hasErrors && hasErrors.has(cusName)" class="invalid-feedback">{{ hasErrors && hasErrors.first(cusName) }}</div>
  </div>
</template>
<script>
  export default {
    inheritAttrs: false,
    name: 'fg-text-area',
    props: {
      hasErrors: {},
      isFields: {},
      cusName:String,
      rows:String,
      cols:String,
      type: String,
      label: String,
      value: [String, Number],
      addonRightIcon: String,
      addonLeftIcon: String
    },
    methods:{
      isInputValid(){
        var boolean = false;
        if(this.isFields && this.isFields[this.cusName]){
          boolean = this.isFields[this.cusName].valid;
        }
        return boolean;
      },
      inputEvent(name, value){
        this.isInputValid();
        this.$emit(name, value);
      }
    },
    computed: {
      hasIcon () {
      const {addonRight, addonLeft} = this.$slots;
      return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Inputs/formGrouptextArea.vue